export default "__VITE_ASSET__CZbTJXnR__"